// eslint-disable-next-line no-unused-vars
import { h } from "preact";

import styles from "./ConnectingAnimation.css";

function ConnectingAnimation(params) {
  const animationSVG = `<svg width="145" height="25" viewBox="0 0 145 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6.5" cy="12.5" r="1" fill="#CECECE" stroke="#CECECE"/>
    <path d="M10.5 7.5C13.5 11 13.5 13.5 10.5 17.5" stroke="#81878C" stroke-width="3" stroke-linecap="round"/>
    <path class="${styles['shape2']}" d="M15 3C20.3333 9.65 20.3333 14.4 15 22" stroke="#535B62" stroke-width="3" stroke-linecap="round"/>
    <path class="${styles['p20']}" d="M39 12.5H45" stroke="#535B62" stroke-width="3" stroke-linecap="round"/>
    <path class="${styles['p40']}" d="M54 12.5H60" stroke="#535B62" stroke-width="3" stroke-linecap="round"/>
    <path class="${styles['p60']}" d="M69 12.5H75" stroke="#535B62" stroke-width="3" stroke-linecap="round"/>
    <path class="${styles['p80']}" d="M84 12.5H90" stroke="#CECECE" stroke-width="3" stroke-linecap="round"/>
    <path class="${styles['p100']}" d="M99 12.5H105" stroke="#CECECE" stroke-width="3" stroke-linecap="round"/>
    <path d="M127 7.5L129 7.5" stroke="#535B62" stroke-width="2" stroke-linecap="round"/>
    <path d="M127 16.5H129" stroke="#535B62" stroke-width="2" stroke-linecap="round"/>
    <path d="M132 16.5H133" stroke="#81878C" stroke-width="2" stroke-linecap="round"/>
    <path d="M132 7.5H133" stroke="#81878C" stroke-width="2" stroke-linecap="round"/>
    <path d="M122.5 12V19C122.5 20.1046 123.395 21 124.5 21H140.5C141.605 21 142.5 20.1046 142.5 19V12M122.5 12V5C122.5 3.89543 123.395 3 124.5 3H140.5C141.605 3 142.5 3.89543 142.5 5V12M122.5 12H142.5" stroke="#CECECE" stroke-width="3" stroke-linecap="round"/>
</svg>
`;

  return (
    // eslint-disable-next-line react/no-danger
    <div
      class={`${styles["mb16"]}`}
      dangerouslySetInnerHTML={{ __html: animationSVG }}
    />
  );
}

export default ConnectingAnimation;



// WEBPACK FOOTER //
// ./components/ConnectingAnimation/ConnectingAnimation.js